import { brandName, navLinks } from '@/mocks/clearing';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1180px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 font-heading text-lg font-bold text-primary-800">
                黑
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">{brandName}</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-[1.9] text-background-200">
              黑料学生汇集学生黑料澄清、辟谣、反转与当事人回应，按完整时间线整理每一句流传的说法。
              洗白还是实锤，看证据，不站队。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['澄清专区', '辟谣台账', '反转档案', '回应原话'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-primary-800 px-3 py-1.5 font-label text-[11px] text-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-label text-xs tracking-[0.2em] text-background-300 uppercase">
              页面导航
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-background-200 transition-colors duration-200 hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-label text-xs tracking-[0.2em] text-background-300 uppercase">
              理性吃瓜声明
            </h4>
            <p className="mt-5 text-sm leading-[1.9] text-background-200">
              本站内容均为公开流传信息的整理与时间线梳理，不构成对任何个人或机构的事实认定。
              涉及身份信息的内容已做隐去处理；若你认为某条整理存在偏差，欢迎提供材料，我们会重新核对。
            </p>
            <div className="mt-6 flex items-center gap-2 font-label text-xs text-background-300">
              <i className="ri-time-line" />
              条目更新截至 2026-09-11
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-300">
            © 2026 {brandName} · 澄清 / 辟谣 / 反转台账
          </p>
          <p className="font-label text-xs text-background-300">
            看清时间线，再决定要不要相信
          </p>
        </div>
      </div>
    </footer>
  );
}